export const UNBINNED = "__unbinned__" as const;

export const MAX_AUTO_DIMENSION_BREAKOUTS = 5;
